export const testimonials = [
    {
        id: 0,
        review: "“خسرت 12 كجم خلال 3 أشهر بخطة تغذية واضحة ومتابعة يومية. ما شعرتش بالجوع أبدًا، والمدرب كان بيعدّل الخطة حسب تقدمي.”",
        name: "أحمد مصطفى",
        location: "القاهرة، مصر",
        img: "/avatars/male.svg"
    },
    {
        id: 1,
        review: "“كان عندي ألم أسفل الظهر من القعدة الطويلة، ومع تمارين العلاج الطبيعي والجدول التدريجي الألم اختفى ووضعية جسمي اتحسنت جدًا.”",
        name: "مريم علي",
        location: "الإسكندرية، مصر",
        img: "/avatars/female.svg"
    },
    {
        id: 2,
        review: "“كرياضي هاوي ركزت على القوة والحركة. خلال 8 أسابيع زادت الأوزان اللي برفعها وبقيت خفّ على الملعب. البرنامج عملي وممتع.”",
        name: "عمر خالد",
        location: "الرياض، السعودية",
        img: "/avatars/male.svg"
    },
    {
        id: 3,
        review: "“أم عاملة ووقتي قليل. اتعلمت أجهز وجبات صحية سريعة للأطفال وليا، والتنبيهات في التطبيق ساعدتني ألتزم من غير توتر.”",
        name: "منة الله حسين",
        location: "الجيزة، مصر",
        img: "/avatars/female.svg"
    },
    {
        id: 4,
        review: "“كنت مبتدئ تمامًا ومش عارف أبدأ. المدرب كان صبور جدًا، والبروجرام خطوة بخطوة خلّاني أثق في نفسي وألتزم.”",
        name: "عبدالله فهد",
        location: "جدة، السعودية",
        img: "/avatars/male.svg"
    },
    {
        id: 5,
        review: "“البرنامج الجماعي في الشركة زوّد طاقتي طول اليوم. بقت نومتي أحسن وتركيزي أعلى، وحسيت بفارق حقيقي في أسبوعين.”",
        name: "سارة نبيل",
        location: "دبي، الإمارات",
        img: "/avatars/female.svg"
    },
    {
        id: 6,
        review: "“كنت عايزة أكون في أحسن فورمة قبل الفرح. اكتسبت شكل مشدود وثقة في النفس، وكل ده من غير حرمان.”",
        name: "نوران أشرف",
        location: "طنطا، مصر",
        img: "/avatars/female.svg"
    },
    {
        id: 7,
        review: "“تحاليل السكر اتحسنت من مرحلة ما قبل السكري لمستوى طبيعي بفضل تنظيم الأكل والمشي اليومي والمتابعة الأسبوعية.”",
        name: "محمود ربيع",
        location: "المنصورة، مصر",
        img: "/avatars/male.svg"
    }
]